import { render, staticRenderFns } from "./StatisticsWdTurnoverMerchantChart.vue?vue&type=template&id=4cf7a2ce&"
import script from "./StatisticsWdTurnoverMerchantChart.vue?vue&type=script&lang=js&"
export * from "./StatisticsWdTurnoverMerchantChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports